

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ element: Component, isProtected, allowedRoles }) => {

  const userType = localStorage.getItem("userType");
  const token = localStorage.getItem("token");
  const location = useLocation();
  const module = localStorage.getItem('Module');

  // Redirect if route is protected and user is not authenticated
  if (isProtected && !token && !userType) {
    return <Navigate to="/Home" replace />;
  }

   // If allowedRoles is defined and userType is not in it, restrict access
   if (allowedRoles && !allowedRoles.includes(userType)) {
    return <Navigate to="/Home" replace />;
  }

  // Redirect authenticated users away from login or register pages
  if (!isProtected && token && (location.pathname === "/Login" || location.pathname === "/Register")) {
    if (module === "Candidate") {
      return <Navigate to="/Home" replace />;
    } else if (["Recruiter", "Company", "Institution"].includes(module)) {
      return <Navigate to="/Home" replace />;
    }
  }

  // Redirect authenticated users to the appropriate page when reopening the app
  if (token && !isProtected && (location.pathname === "/" || location.pathname === "/Login" || location.pathname === "/Register")) {
    if (module === "Candidate") {
      return <Navigate to="/Home" replace />;
    } else if (["Recruiter", "Company", "Institution"].includes(module)) {
      return <Navigate to="/Home" replace />;
    }
  }

  return Component;
};

export default PrivateRoute;


